import React, { useState, useEffect } from "react";
import { useImx } from "../../contexts/ImxContext";

const EthereumAddress = ({ account }) => {
  const { ethereumClient } = useImx();
  const [displayAccount, setDisplayAccount] = useState("0x???");

  useEffect(() => {
    if (account) {
      if (account === "Zombies") {
        setDisplayAccount("Zombies");
      } else {
        setDisplayAccount(ethereumClient.addressName(account));
        const loadDisplayAccount = async () => {
          const displayAccount = await ethereumClient.addressNameResolve(account);
          setDisplayAccount(displayAccount);
        };
        loadDisplayAccount().catch(console.warn);
      }
    }
  }, [account]);

  return <>{displayAccount}</>;
};

export default EthereumAddress;
